import RailsResource from './rails-resource';

export default new class StudentService extends RailsResource {
  constructor() {
    super({
      url: '/admin',
      resource: 'students',
      ajaxLoader: false
    });
  }

  // GET resources
  all(enrollment) {
    if (!enrollment)
      return super.all();

    return this.get(this.endpoint({
      path: this.route,
      queryParams: [`enrollment=${enrollment}`]
    }));
  }

  // PATCH to-guardian
  toGuardian(studentId) {
    return this.patch(`${this.url}/${this.resource}/${studentId}/to-guardian.json`, true)
  }

  // PATCH merge-guardian
  mergeGuardian(studentId, guardianId) {
    return this.patch(`${this.url}/${this.resource}/${studentId}/guardian/${guardianId}/merge.json`, true)
  }
};